import { useState } from "react";
import config from "../config";
import { BOOKING_REQUEST_TEXT, PRACTICE } from "../data/practice";

const PANEL_ID = "scheduling-details";
const CONTACT_EMAIL = config.business.contactEmail;
const CANCEL_HOURS = PRACTICE.cancellationWindowHours;

export default function SchedulingInfo() {
  const [open, setOpen] = useState(false);
  return (
    <div className="card scheduling-card">
      <h3 className="sched-heading">
        <button
          type="button"
          className="sched-header"
          onClick={() => setOpen(v => !v)}
          aria-expanded={open}
          aria-controls={PANEL_ID}
        >
          <span>How scheduling works</span>
          <span className="chev" aria-hidden="true">{open ? "–" : "+"}</span>
        </button>
      </h3>

      {/* teaser (always visible) */}
      <ul className="sched-teaser">
        <li>Not sure where to start? <a href="#request-a-call"><strong>Request a call</strong></a>.</li>
        <li>Start with a personalized <strong>intake</strong>.</li>
        <li><strong>50-min</strong> sessions available virtually; in-home art therapy available in Nassau.</li>
        <li><strong>Extended</strong> options available.</li>
        <li><strong>Art therapy, talk therapy</strong>, free groups &amp; workshops.</li>
        <li>Easy online booking • <strong>{CANCEL_HOURS}-hour</strong> change window.</li>
        <li><strong>Sliding scale available upon request.</strong></li>
      </ul>

      {/* full text (collapsible). Collapsed = visibility:hidden in App.css,
          so the mailto link can't take focus or be read while hidden. */}
      <div
        id={PANEL_ID}
        className={`sched-panel ${open ? "open" : ""}`}
        role="region"
        aria-label="How scheduling works, full details"
      >
        <div className="policy-content">
          <p>
            At Healing Hues, scheduling therapy is designed to be simple and flexible. Not sure where to start? Request
            a call: leave your number and the times that work for you, and we’ll figure it out together.
          </p>
          <p>
            When you’re ready to begin, we’ll start with a personalized intake session to get to know each other and set
            your care plan in motion. Ongoing sessions are typically 50 minutes and are available virtually. In-home art
            therapy sessions are also available within Nassau for those who prefer to be seen in their own space.
            Extended sessions are available if you’d like more time to reflect and reconnect. I offer individual art
            therapy and talk therapy, free art therapy groups for adults, teens, and families, and workshops open to the
            wider community.
          </p>
          {/* Her copy says the online system lets you "book, cancel, or
              reschedule"; this build has no online cancel/reschedule, so
              changes are made by replying to the confirmation email. */}
          <p>
            After your intake, sessions can be scheduled regularly or as needed. Book online anytime.{" "}
            {BOOKING_REQUEST_TEXT} To cancel or reschedule, reply to your confirmation email at least {CANCEL_HOURS} hours
            ahead so that time can be offered to someone else.
          </p>
          <p>
            Sliding scale available upon request. To ask about reduced rates, email{" "}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
          <p>Questions? Reach out anytime. I’m here to help.</p>
        </div>
      </div>
    </div>
  );
}
